import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List/List";
import Typography from "@material-ui/core/Typography/Typography";
import { useTranslation } from "react-i18next";
import "./css/cartOffer.scss";
import { IOffer } from "./ICart";

interface IParams {
    offer: IOffer;
    handleOfferClick(selectedOffer: IOffer): void;
}

export const CartOffer = (props: IParams) => {
    const { offer } = props;
    const { t } = useTranslation(["glossary", "common"]);

    return (
        <Card className="offer" elevation={2}>
            <CardContent className="offer-content">
                <Typography color="inherit" variant="h3">
                    {offer.description}
                </Typography>
                <List className="offer-content__list">
                    {offer.usages.map((usage, index) => (
                        <Typography
                            className="xtest_offers"
                            color="inherit"
                            /* eslint-disable-next-line react/no-array-index-key */
                            key={index}
                            variant="body1"
                        >
                            {usage.description}
                        </Typography>
                    ))}
                </List>
                <Grid alignItems="center" container>
                    <Grid item sm={6} xs={7}>
                        <Button
                            className="xtest_tac_button"
                            color="secondary"
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={() => props.handleOfferClick(offer)}
                        >
                            {t("glossary:buyNow")}
                        </Button>
                    </Grid>
                    <Grid item sm={6} xs={5}>
                        <Typography align="right" color="inherit" variant="h4">
                            {t("common:price", { price: offer.recurringChargeAmount })}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
